import styled from 'styled-components'

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${props => props.theme.spacing.sp16};

  @media screen and (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`
